import projectSettings from "../../assets/Js/projectSettings";
import groupAvatar from "../../assets/Images/groupAvatar.svg";
import avatar from "../../assets/Images/avatar.jpg";
import gymAvatar from "../../assets/Images/bgImg.jpg";
import { useEffect, useState } from "react";

export default function DisplayPicture({
  image,
  className,
  defaultMaxHeight = "300px",
  showGroupAvatar = false,
  gif = null,
  isLocalImage = false,
  showGymAvatar = false
}) {
  const [errorOccured, setErrorOccured] = useState(false);
  const [displayImage, setDisplayImage] = useState(
    showGymAvatar ? gymAvatar:  (showGroupAvatar ? groupAvatar : avatar)
  );

  useEffect(() => {
    let whichAvatar = showGymAvatar ? gymAvatar :  (showGroupAvatar ? groupAvatar : avatar);
    let _image = image;

    if (!isLocalImage) {
      _image =
        image && image !== "null"
          ? `${projectSettings.baseImageUrl}=${image}`
          : whichAvatar;
    }

    setDisplayImage(_image);
  }, [image, gif, showGroupAvatar, isLocalImage, showGymAvatar]);

  useEffect(() => {
    if (errorOccured) {
      setDisplayImage(showGymAvatar ? gymAvatar:  (showGroupAvatar ? groupAvatar : avatar));
    }
  }, [errorOccured]);

  const anErrorOccured = () => {
    setErrorOccured({
      errorOccured: true,
    });
  };

  return gif ? (
    <img src={gif} alt="gif" className={className} />
  ) : (
    <img
      src={displayImage}
      style={{maxHeight: defaultMaxHeight, objectFit: "cover"}} 
      alt="profile"
      className={`smoothImage ${className}`}
      onError={anErrorOccured}
    />
  );
}
